module.exports = __webpack_public_path__ + "img/31.371f6536.jpg";